import { SharedSubFlowV2BlockFormFields } from './SharedFormFields';
import { FlowKind } from '../../constants';

export function SubFlowFormFields() {
  return (
    <SharedSubFlowV2BlockFormFields
      fieldNamePrefix="config"
      variant="SubflowPicker"
      allowedFlowKinds={[FlowKind.Base]}
    />
  );
}
